import styled from 'styled-components';

const FieldColumn = styled.div`
  margin-bottom: .5rem;
`
export default FieldColumn;